export function bannerClasses() {
  return "fixed left-3 bottom-3 bg-white shadow-lg rounded-lg py-3 px-3 border-2 border-red-500 transition-all pointer-events-auto";
}